import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function VerticalDivider({ className, height, ...rest }) {
    const style = height ? { height } : null;
    return (
        <div
            data-component="VerticalDivider"
            className={cx('sarsa-vertical-divider', className)}
            style={style}
            {...rest} />
    );
}


VerticalDivider.propTypes = {
    /** Additional className added to container */
    className: PropTypes.string,

    /** Divider's height. Must be valid css unit such as "100px" or "1.5rem" */
    height: PropTypes.string
};
